import { useEffect, useRef, useState } from "react";

// Pulse only for new priority alerts, never for a repeated poll or a lower count.
export const useNotificationAttention = (count: number) => {
  const previous = useRef(count);
  const [attention, setAttention] = useState(false);
  useEffect(() => {
    const increased = count > previous.current;
    previous.current = count;
    if (!increased) {
      if (!count) setAttention(false);
      return;
    }
    setAttention(true);
    const timer = window.setTimeout(() => setAttention(false), 1800);
    return () => {
      window.clearTimeout(timer);
      setAttention(false);
    };
  }, [count]);
  return attention;
};
